import { useUnit } from 'effector-react';
import { gameModel } from 'entities/game';
import { Button } from 'shared/ui';
import { calculatorBetModel } from '../../model';
import cls from './calculator-bet-fast-bets.module.scss';

export const CalculatorBetFastBets = () => {
	const [fastBets, fastBet] = useUnit([
		gameModel.$fastBets,
		calculatorBetModel.fastBetButtonClicked,
	]);

	return (
		fastBets.length > 0 && (
			<div className={cls.calculatorBetFastBets}>
				{fastBets.map((bet) => (
					<Button
						key={bet}
						fullWidth
						className={cls.calculatorBetFastBetsButton}
						onClick={() => fastBet(bet)}
					>
						{bet}
					</Button>
				))}
			</div>
		)
	);
};
